import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import useBreakpoints from '#client/hooks/useBreakpoints';

import { AccountWrapper } from './AccountSkeleton.styles';

export default function AccountSkeleton() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <AccountWrapper>
      <Stack
        direction="column"
        spacing="16px"
        width="100%"
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          width="100%"
        >
          <Stack
            alignItems="center"
            direction="row"
            spacing="16px"
          >
            <Stack>
              <Skeleton
                height={isDesktop ? 44 : 40}
                width={isDesktop ? 44 : 40}
              />
            </Stack>
            <Stack
              alignItems="start"
              direction="column"
              spacing="4px"
            >
              <Skeleton
                height={isDesktop ? 44 : 40}
                width={isDesktop ? 200 : 150}
              />
            </Stack>
          </Stack>
          <Skeleton
            height={isDesktop ? 56 : 40}
            width={isDesktop ? 120 : 95}
          />
        </Stack>
      </Stack>
    </AccountWrapper>
  );
}
